/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { EbsSnapshotTarget } from '../models/EbsSnapshotTarget';

export class EbsSnapshotRestoreDestination {
  'awsEbs'?: EbsSnapshotTarget;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "awsEbs",
      "baseName": "awsEbs",
      "type": "EbsSnapshotTarget",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return EbsSnapshotRestoreDestination.attributeTypeMap;
  }

  public constructor() {
  }
}

